import classnames from 'classnames';
import { forwardRef } from 'react';

import { Text, type TextProps } from '@/core/tamagoshi/Text/Text';

import styles from './Typography.module.scss';

export const Link = forwardRef<HTMLAnchorElement, Omit<TextProps<'a'>, 'tag'>>(
  ({ className, href, weight, children, ...otherProps }, ref) => {
    const rootClassnames = classnames(styles.link, className);
    return (
      <Text
        ref={ref}
        className={rootClassnames}
        tag="a"
        weight={weight}
        href={href}
        {...otherProps}
      >
        {children}
      </Text>
    );
  },
);
